'use client';

import { Button } from '@repo/ui/button';

import { useContactDialog } from './contact-dialog-context';

export function ReadyToBuild() {
  const { openContactDialog } = useContactDialog();

  return (
    <section className="relative bg-gradient-to-r from-primary/80 to-primary py-32 text-center dark:from-accent dark:to-primary/80">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold sm:text-5xl">
          Ready to Build{' '}
          <span className="relative inline-block before:absolute before:-inset-1 before:block before:-skew-y-[1.5deg] before:bg-white/40 before:content-['']">
            <span className="relative">What&apos;s Next?</span>
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-accent-foreground">
          From MVPs to enterprise modernization, LexLogic delivers custom software that drives
          growth and scales with your business.
        </p>
        <div className="mt-10">
          <Button size="lg" variant="secondary" className="px-8 py-3" onClick={openContactDialog}>
            Start Your Project
          </Button>
        </div>
      </div>
    </section>
  );
}
